// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"dc56f070","414":"9f7ee1b6","658":"9c0c4ccf","787":"ceffe7f5"}[chunkId] + ".chunk.js";
};